// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__WeQuO","logOutButton":"Header_logOutButton__1MlDE","logoAndHomeIconContainer":"Header_logoAndHomeIconContainer__8RSNR"};